import over from 'lodash/fp/over'
import pipe from 'lodash/fp/pipe'
import prop from 'lodash/fp/prop'
import Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as AppUtils from '../../utils'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Holidays from './holidays'
import * as Types from './types'

const selectedSchedules: any = prop('schedules')
type SelectFormFields = (state: ApplicationState) => Form.Fields<Types.FormFields>
const selectFormFields: SelectFormFields = pipe(
  selectedSchedules,
  Form.selectFormFields,
)

const createArgs = over<App.CommunityIdentifier | any>([
  AppUtils.selectedCommunity,
  selectFormFields,
])

type AddScheduleEpic =
  (action$: ReduxObservable.ActionsObservable<Form.SaveAction<void>>, store: Redux.Store<ApplicationState>) =>
    Observable<Actions.CreateActionCreator>

const addSchedule: AddScheduleEpic = (action$, store) =>
  action$.ofType(Actions.FormConstants[Form.SAVE])
    .map(() => store.getState())
    .map(createArgs)
    .map((args) => Actions.create.apply(null, args))

type AddScheduleErrorEpic = (action$: ReduxObservable.ActionsObservable<any>) =>
  Observable<Form.SaveCompleteAction>
const addScheduleError: AddScheduleErrorEpic = (action$) =>
  action$.ofType(Request.errorConstant(Constants.ADD_SCHEDULE))
    .map(Actions.FormActions[Form.SAVE_COMPLETE])

type AddScheduleSuccessEpic = (action$: ReduxObservable.ActionsObservable<any>) =>
  Observable<Form.SaveCompleteAction | Form.ResetAction | Actions.ToggleModal>
const addScheduleSuccess: AddScheduleSuccessEpic = (action$) =>
  action$.ofType(Request.successConstant(Constants.ADD_SCHEDULE))
    .mergeMap(() => [
      Flash.showFlashMessage('Schedule created!'),
      Actions.FormActions[Form.SAVE_COMPLETE](),
      Actions.FormActions[Form.RESET](),
      Actions.toggleModal(),
    ])

const refreshEpic = (event: string) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
  ) =>
    action$.ofType(Request.successConstant(event))
    .map(() => Actions.fetch(store.getState().app.selectedCommunity))

export const pageLoadEpic = (url: string) =>
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
    {history}: App.Dependencies,
  ) => action$.ofType(Router.ON_ENTER)
    .filter(() => history.location.pathname.includes(url))
    .map(() => Actions.fetch(store.getState().app.selectedCommunity))

const saveHolidays = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
) =>
  action$.ofType(Holidays.SAVE_HOLIDAYS)
  .map(() => Holidays.submitHolidayUpdate(
    store.getState().app.selectedCommunity,
    store.getState().schedules.holidays.state.data))

export const epic = ReduxObservable.combineEpics(
  addSchedule,
  addScheduleError,
  addScheduleSuccess,
  saveHolidays,
  pageLoadEpic(Menu.NEWSLETTER_SCHEDULES_URL),
  refreshEpic(Constants.ADD_SCHEDULE),
  refreshEpic(Constants.UPDATE_SCHEDULE),
  Flash.createFlashErrorEpic(Holidays.UPDATE_HOLIDAYS, 'There was a problem saving your holiday schedule changes'),
  Form.validateForm('schedules', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
  Form.validateFormOnOpen('schedules', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
  IsActive.createStatusUpdateEpic(Constants.UPDATE_SCHEDULE, Actions.update),
)



// WEBPACK FOOTER //
// ./src/pages/schedules/epic.ts